import React, { useState, useCallback } from "react";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from "../Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds,MobileUnderCalAds } from "../../Ads";
const TITLE = "حساب طاقة الحركة - احسب طاقة الحركة، الكتلة، أو السرعة";
const DESCRIPTION =
  "حاسب طاقة الحركة الشامل: قم بحساب طاقة الحركة، الكتلة، أو السرعة بناءً على القيم المدخلة للكتلة، السرعة، أو طاقة الحركة. أداة دقيقة وسهلة الاستخدام.";
const KEYWORDS =
  "طاقة الحركة, حساب طاقة الحركة, حاسبة طاقة الحركة, حساب الكتلة, حساب السرعة, فيزياء";
const OG_URL = "https://do-calculate.com/calculator/ar/kineticenergy";
function KineticEnergyCalculator() {
  const [mass, setMass] = useState("");
  const [speed, setSpeed] = useState("");
  const [kineticEnergy, setKineticEnergy] = useState("");
  const [calculationMode, setCalculationMode] = useState(
    "calculateKineticEnergy"
  );
  const [error, setError] = useState("");
  const [showSteps, setShowSteps] = useState(false);
  const updateCalculations = useCallback(() => {
    setError("");
    const massValue = parseInt(mass, 10) || 0;
    const speedValue = parseInt(speed, 10) || 0;
    const kineticEnergyValue = parseInt(kineticEnergy, 10) || 0;
    switch (calculationMode) {
      case "calculateKineticEnergy":
        if (massValue > 0 && speedValue > 0) {
          const calculatedKineticEnergy =
            0.5 * massValue * speedValue * speedValue;
          setKineticEnergy(Math.round(calculatedKineticEnergy));
        } else {
          setError("الرجاء إدخال الكتلة والسرعة بشكل صحيح");
        }
        break;
      case "calculateMass":
        if (kineticEnergyValue > 0 && speedValue > 0) {
          const calculatedMass =
            (2 * kineticEnergyValue) / (speedValue * speedValue);
          setMass(Math.round(calculatedMass));
        } else {
          setError("الرجاء إدخال طاقة الحركة والسرعة بشكل صحيح");
        }
        break;
      case "calculateSpeed":
        if (kineticEnergyValue > 0 && massValue > 0) {
          const calculatedSpeed = Math.sqrt(
            (2 * kineticEnergyValue) / massValue
          );
          setSpeed(Math.round(calculatedSpeed));
        } else {
          setError("الرجاء إدخال طاقة الحركة والكتلة بشكل صحيح");
        }
        break;
      default:
        break;
    }
  }, [mass, speed, kineticEnergy, calculationMode]);
  const handleCalculateClick = () => {
    updateCalculations();
    setShowSteps(true);
  };
  const handleMassChange = (e) => setMass(e.target.value);
  const handleSpeedChange = (e) => setSpeed(e.target.value);
  const handleKineticEnergyChange = (e) => setKineticEnergy(e.target.value);
  const handleModeChange = (e) => setCalculationMode(e.target.value);
  const getSolutionSteps = () => {
    switch (calculationMode) {
      case "calculateKineticEnergy":
        return (
          <div className="alert alert-info">
            <h4>خطوات حساب طاقة الحركة:</h4>
            <ol>
              <li>ادخل الكتلة (بالكيلوجرام) في الحقل المخصص.</li>
              <li>ادخل السرعة (بالمتر/ثانية) في الحقل المخصص.</li>
              <li>اضغط على زر "احسب" للحصول على طاقة الحركة.</li>
              <li>طاقة الحركة تساوي 0.5 × الكتلة × السرعة².</li>
            </ol>
          </div>
        );
      case "calculateMass":
        return (
          <div className="alert alert-info">
            <h4>خطوات حساب الكتلة:</h4>
            <ol>
              <li>ادخل طاقة الحركة (بالجول) في الحقل المخصص.</li>
              <li>ادخل السرعة (بالمتر/ثانية) في الحقل المخصص.</li>
              <li>اضغط على زر "احسب" للحصول على الكتلة.</li>
              <li>الكتلة تساوي (2 × طاقة الحركة) / السرعة².</li>
            </ol>
          </div>
        );
      case "calculateSpeed":
        return (
          <div className="alert alert-info">
            <h4>خطوات حساب السرعة:</h4>
            <ol>
              <li>ادخل طاقة الحركة (بالجول) في الحقل المخصص.</li>
              <li>ادخل الكتلة (بالكيلوجرام) في الحقل المخصص.</li>
              <li>اضغط على زر "احسب" للحصول على السرعة.</li>
              <li>السرعة تساوي √(2 × طاقة الحركة) / الكتلة.</li>
            </ol>
          </div>
        );
      default:
        return null;
    }
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  تتيح لك حاسبة طاقة الحركة إجراء ثلاث أنواع من الحسابات
                  استنادًا إلى القيم المدخلة. اختر نوع الحساب المناسب لك وأدخل
                  القيم المتوفرة لحساب القيمة المفقودة بدقة وسهولة.
                </p>
                <h2 style={{ fontSize: "17px" }}>
                  إيجاد طاقة الحركة بمعلومية الكتلة والسرعة
                </h2>
                <p>
                  إذا كنت تعرف الكتلة (بـ الكيلوجرام) والسرعة (بـ متر/ثانية)،
                  يمكنك حساب طاقة الحركة (بـ الجول) باستخدام الصيغة التالية:
                </p>
                <p>
                  <b>طاقة الحركة = 0.5 × الكتلة × السرعة²</b>
                </p>
                <h2 style={{ fontSize: "17px" }}>
                  إيجاد الكتلة بمعلومية طاقة الحركة والسرعة
                </h2>
                <p>
                  إذا كنت تعرف طاقة الحركة (بـ الجول) والسرعة (بـ متر/ثانية)،
                  يمكنك حساب الكتلة (بـ الكيلوجرام) باستخدام الصيغة التالية:
                </p>
                <p>
                  <b>الكتلة = (2 × طاقة الحركة) / السرعة²</b>
                </p>
                <h2 style={{ fontSize: "17px" }}>
                  إيجاد السرعة بمعلومية الكتلة وطاقة الحركة
                </h2>
                <p>
                  إذا كنت تعرف الكتلة (بـ الكيلوجرام) وطاقة الحركة (بـ الجول)،
                  يمكنك حساب السرعة (بـ متر/ثانية) باستخدام الصيغة التالية:
                </p>
                <p>
                  <b>السرعة = √((2 × طاقة الحركة) / الكتلة)</b>
                </p>
                <p>
                  استخدم هذه الأداة لإدخال القيم المتاحة وحساب القيمة المفقودة
                  بدقة، مما يسهل عليك إجراء الحسابات الفيزيائية المتعلقة بالطاقة
                  الحركية.
                </p>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <hr />
                <div dir="rtl">
                  <div className="form-group align-items-center">
                    <b>
                      <label
                        className="form-label ms-2"
                        htmlFor="calculationMode"
                      >
                        اختر نوع الحساب
                      </label>
                    </b>
                    <div id="calculationMode">
                      <br />
                      <div>
                        <input
                          type="radio"
                          id="calculateKineticEnergy"
                          name="calculationMode"
                          value="calculateKineticEnergy"
                          checked={calculationMode === "calculateKineticEnergy"}
                          onChange={handleModeChange}
                        />
                        <label
                          htmlFor="calculateKineticEnergy"
                          className="ms-2"
                        >
                          حساب طاقة الحركة
                        </label>
                      </div>
                      <div className="ms-3">
                        <input
                          type="radio"
                          id="calculateMass"
                          name="calculationMode"
                          value="calculateMass"
                          checked={calculationMode === "calculateMass"}
                          onChange={handleModeChange}
                        />
                        <label htmlFor="calculateMass" className="ms-2">
                          حساب الكتلة
                        </label>
                      </div>
                      <div className="ms-3">
                        <input
                          type="radio"
                          id="calculateSpeed"
                          name="calculationMode"
                          value="calculateSpeed"
                          checked={calculationMode === "calculateSpeed"}
                          onChange={handleModeChange}
                        />
                        <label htmlFor="calculateSpeed" className="ms-2">
                          حساب السرعة
                        </label>
                      </div>
                    </div>
                  </div>
                  <br />
                  {calculationMode !== "calculateMass" && (
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2" htmlFor="massInput">
                          الكتلة (كيلوجرام)
                        </label>
                      </b>
                      <input
                        id="massInput"
                        type="number"
                        placeholder="80"
                        value={mass}
                        onChange={handleMassChange}
                        className="form-control"
                        style={{ width: "90%" }}
                      />
                    </div>
                  )}
                  {calculationMode !== "calculateSpeed" && (
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2" htmlFor="speedInput">
                          السرعة (متر/ثانية)
                        </label>
                      </b>
                      <input
                        id="speedInput"
                        type="number"
                        placeholder="8"
                        value={speed}
                        onChange={handleSpeedChange}
                        className="form-control"
                        style={{ width: "90%" }}
                      />
                    </div>
                  )}
                  {calculationMode !== "calculateKineticEnergy" && (
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label
                          className="form-label ms-2"
                          htmlFor="kineticEnergyInput"
                        >
                          طاقة الحركة (جول)
                        </label>
                      </b>
                      <input
                        id="kineticEnergyInput"
                        type="number"
                        placeholder="320"
                        value={kineticEnergy}
                        onChange={handleKineticEnergyChange}
                        className="form-control"
                        style={{ width: "90%" }}
                      />
                    </div>
                  )}
                  <br />
                  <button
                    className="btn btn-success"
                    style={{ fontSize: "20px" }}
                    onClick={handleCalculateClick}
                  >
                    احسب                  </button>
                  <br/>                  <div>
                    { (
                      <>
                        {error !== "" && (
                          <p className="p-3 mb-2 bg-warning text-white">
                            خطأ: {error}
                          </p>
                        )}
                        {calculationMode === "calculateKineticEnergy" &&
                          kineticEnergy !== "" && (
                            <p className="p-3 mb-2 bg-success text-white">
                              طاقة الحركة (جول): {kineticEnergy} جول
                            </p>
                          )}
                        {calculationMode === "calculateMass" && mass !== "" && (
                          <p className="p-3 mb-2 bg-success text-white">
                            الكتلة (كيلوجرام): {mass} كيلوجرام
                          </p>
                        )}
                        {calculationMode === "calculateSpeed" &&
                          speed !== "" && (
                            <p className="p-3 mb-2 bg-success text-white">
                              السرعة (متر/ثانية): {speed} متر/ثانية
                            </p>
                          )}
                        {showSteps && getSolutionSteps()}
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
         </div>
</div>
  );
}
export default KineticEnergyCalculator;
